"use client";

import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";
import ProjectRadarFilter from "..";

import Modal from "src/components/common/responsiveModal";
import SubscribeModal from "src/components/listing-search/project-radar-banner/ subscribeModal";

import Filter from "src/assets/svg/project-radar/filter.svg";

import styles from "./styles.module.css";

const ModalFilter = ({ filters, criteria }) => {
  const [isOpenFilterModal, setOpenFilterModal] = useState(false);
  const [isremovePassive, setIsremovePassive] = useState();
  const [isOpenSubscribeModal, setIsOpenSubscribeModal] = useState(false);

  const subscribeOpenClick = () => {
    window.location.hash = "proje-radari-abone";
    setIsOpenSubscribeModal(true);
    setTimeout(() => {
      Ga4WithEventParameters(
        {
          eventName: "proje-radari",
          eventParameters: { label: "abone-ol" },
        },
        300
      );
    });
  };

  const subscribeCloseClick = () => {
    setIsOpenSubscribeModal(false);
    window.history.pushState("", document.title, window.location.pathname + window.location.search);
  };

  const handleOpenFilterModal = () => {
    // g4 event
    setOpenFilterModal(true);
  };

  const handleCloseFilterModal = () => {
    setOpenFilterModal(false);
  };

  const handleDeleteAllButton = async () => {
    localStorage.setItem("openModalAfterRemoveFilter", "true");
    window.location.href = "/proje-radari";

    setTimeout(() => {
      Ga4WithEventParameters({
        eventName: "filtre",
        eventParameters: { label: "click||secimleri-kaldir" },
      });
    }, 300);
  };

  useEffect(() => {
    const shouldOpenModal = localStorage.getItem("openModalAfterRemoveFilter");

    setIsremovePassive(window.location.pathname === "/proje-radari");

    if (shouldOpenModal === "true") {
      setOpenFilterModal(true);
      localStorage.removeItem("openModalAfterRemoveFilter");
    }
  }, []);

  useEffect(() => {
    if (window.location.hash.length > 0 && window.location.hash === "#proje-radari-abone") {
      setIsOpenSubscribeModal(true);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <nav className={styles.navLinks}>
        <button className={styles.button} onClick={subscribeOpenClick}>
          Bültene Abone Ol
        </button>
      </nav>

      <div className={styles.filterButton} onClick={handleOpenFilterModal}>
        <Filter />
        <p>Filtreler</p>
      </div>

      {isOpenFilterModal && (
        <Modal isOpen={isOpenFilterModal} onClose={handleCloseFilterModal} size="small" title="Filtreler">
          <div className={styles.removeFilterWrapper}>
            <button className={styles.removeFilter} onClick={handleDeleteAllButton} disabled={isremovePassive}>
              Seçimleri Kaldır
            </button>
          </div>
          <ProjectRadarFilter filters={filters} setClose={setOpenFilterModal} criteria={criteria} />
        </Modal>
      )}
      <SubscribeModal isOpen={isOpenSubscribeModal} close={subscribeCloseClick} />
    </div>
  );
};

ModalFilter.propTypes = {
  filters: PropTypes.object,
  criteria: PropTypes.object,
};

export default ModalFilter;
